import React, { useEffect, useState } from "react"
import PageTitle from "../components/PageTitle";
import Index from "../view/Privacy/Index";
import { useNavigate, useOutletContext } from "react-router-dom";
import { validateAll } from "indicative/validator";
import ToastAlert from "../common/ToastAlert";
import ApiCall from "../common/ApiCall";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../redux/user/user.action";
import HomeIcon from "../components/Iocns/HomeIcon";
import { getSlugByLang } from "../common/Helper";

export default function PrivacyController() {
    const [setBreadcrumbList] = useOutletContext();
    const [strength, setStrength] = useState(0);
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showNewCPassword, setShowNewCPassword] = useState(false);
    const [isSamePass, setIsSamePass] = useState(false);
    const user = useSelector((state) => state.user);
    const userLang = getSlugByLang(user?.language)
    const [state, setState] = useState({
        password: "",
        newPassword: "",
        newCPassword: "",
        error: [],
    })
    const { password, newPassword, newCPassword } = state

    const navigate = useNavigate();
    const dispatch = useDispatch();


    const checkStrength = (password) => {
        let score = 0;
        let hasUpper = /[A-Z]/.test(password);
        let hasLower = /[a-z]/.test(password);
        let hasNumber = /[0-9]/.test(password);
        let hasSpecial = /[^A-Za-z0-9]/.test(password);
        let isLong = password.length >= 8;
        let isVeryLong = password.length >= 12;

        // Assign points for complexity
        if (hasLower) score++;
        if (hasUpper) score++;
        if (hasSpecial) score++;
        if (hasNumber) score++; // Ensure number is required for stronger passwords

        // Add points only when length is 8+
        if (isLong) score++;
        if (isVeryLong) score++;

        setStrength(score);
    };

    const getClassNames = (index) => {
        if (state.newPassword.length === 0) {
            return 'comSpan';
        }

        const classNames = ['comSpan'];

        if (strength >= 1) {
            classNames[0] = 'comSpan redSpan';
        }
        if (strength >= 2) {
            classNames[1] = 'comSpan yellowSpan';
        }
        if (strength >= 5) {
            classNames[2] = 'comSpan greenSpan';
        }
        return classNames[index] || 'comSpan';
    };


    const handhandleShowPassword = (e, type) => {
        e?.preventDefault();
        if (type == 1) {
            setShowPassword(!showPassword)
        }
        if (type == 0) {
            setShowNewPassword(!showNewPassword)
        }

        if (type == 2) {
            setShowNewCPassword(!showNewCPassword)
        }
    }

    const changeValue = (e) => {
        let value = e.target.value;
        setState({
            ...state,
            [e.target.name]: value
        })
        if (e.target.name == 'newPassword') {
            checkStrength(value);
        }
        if (e.target.name == 'newPassword') {
            checkStrength(value);
            if (value && newCPassword && value === newCPassword) {
                setIsSamePass(true)
            } else {
                setIsSamePass(false)
            }
        }
        if (e.target.name == 'newCPassword') {
            if (newPassword && value === newPassword) {
                setIsSamePass(true)
            } else {
                setIsSamePass(false)
            }

        }
    }

    useEffect(() => {
        dispatch(setLoading(false))
        setBreadcrumbList([
            {
                name: <HomeIcon />,
                url: '/' + userLang
            },
            {
                name: "Privacy"
            },
        ])
    }, [user?.language]);


    const submit = (e) => {

        e?.preventDefault();

        let rules = {}
        // if (state.password) {
            rules['password'] = "required"
            rules['newPassword'] = "required"
            rules['newCPassword'] = "required|same:newPassword"
        // }


        const message = {
            'password.required': 'Current Password is Required.',
            'newPassword.required': 'New Password is Required.',
            'newCPassword.required': 'Confirm Password is Required.',
            'newCPassword.same': 'Confirm password must be same as new password .',
        }

        validateAll(state, rules, message).then(async () => {
            dispatch(setLoading(true))
            const formaerrror = {};
            if (state.password) {
                if (!(strength >= 5)) {
                    formaerrror['newPassword'] = 'Please enter strong password'
                }
            }

            if (Object.keys(formaerrror).length) {
                setState({
                    ...state,
                    error: formaerrror
                })
                dispatch(setLoading(false))
                return false;
            }

            setState({
                ...state,
                error: formaerrror
            })

            let data = {}
            if (state.password) {
                data.password = state.password
                data.newPassword = state.newPassword
                data.newCPassword = state.newCPassword
            }


            const changePassword = await ApiCall('post', 'change-password', data, user.token)
            dispatch(setLoading(false))
            if (changePassword) {

                if (changePassword?.data?.success) {
                    setState({
                        ...state,
                        newCPassword: "",
                        newPassword: "",
                        password: "",
                        error: {}
                    })

                    ToastAlert({ msg: changePassword.data.message, msgType: 'success' });


                } else {

                    if (changePassword?.data?.errors && Object.keys(changePassword?.data?.errors).length) {

                        setState({
                            ...state,
                            error: changePassword?.data?.errors,
                        })

                    } else {
                        const formaerrror = {};
                        formaerrror.password = changePassword?.data?.message
                        setState({
                            ...state,
                            error: formaerrror,

                        })
                        // ToastAlert({ msg: verifyOtp.data.message, msgType: 'error' });
                    }
                }
            } else {
                ToastAlert({ msg: 'Something went wrong', msgType: 'error' });
            }



        }).catch(errors => {
            dispatch(setLoading(false))
            const formaerrror = {};
            if (errors.length) {
                errors.forEach(element => {
                    formaerrror[element.field] = element.message
                });
            } else {
                ToastAlert({ msg: errors?.message ?? 'Something went wrong', msgType: 'error' });
            }
            setState({
                ...state,
                error: formaerrror,
            })


        });

    }


    return (
        <>
            <PageTitle title={'Privacy'} />
            <Index
                state={state}
                getClassNames={getClassNames}
                handhandleShowPassword={handhandleShowPassword}
                changeValue={changeValue}
                showNewPassword={showNewPassword}
                showPassword={showPassword}
                submit={submit}
                showNewCPassword={showNewCPassword}
            />
        </>
    )

}